import type { LabelHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export function Label({
	className,
	...props
}: LabelHTMLAttributes<HTMLLabelElement>) {
	return (
		// biome-ignore lint/a11y/noLabelWithoutControl: generic primitive; callers pass htmlFor
		<label
			className={cn(
				"font-medium text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
				className
			)}
			{...props}
		/>
	);
}
